"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedField = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const orm_1 = require("../orm");
class LocalizedField extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this.en = "";
        this.de = "";
        this.es = "";
        this.pt = "";
        this.cs = "";
        this.ru = "";
        this.zh = "";
        this.ko = "";
        this.fr = "";
    }
}
exports.LocalizedField = LocalizedField;
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNotEmpty)({ message: "English translations shouldn't be empty" }),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "en", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "de", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "es", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "pt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "cs", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "ru", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "zh", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "ko", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Transform)((value) => value || ""),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], LocalizedField.prototype, "fr", void 0);
//# sourceMappingURL=LocalizedField.js.map